import { useState } from 'react';
import { faqs } from '@/mocks/articles';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">关于飞行，你想知道的一切都在这里</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-500 transition-transform duration-300`}>
                  <i className={`text-lg transition-transform duration-300 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}